<template>
    <section>
        <!-- <div v-if="isExternal === false">
            <InLogin/>
        </div>
        <div v-else>
            <ExLogin/>
        </div> -->
      <IntergrateLogin/>
    </section>
</template>

<script>
// import ExLogin from "./external/ExLogin";
// import InLogin from "./internal/InLogin";
import IntergrateLogin from "./integrate/IntegrateLogin";
import { mapState, mapActions } from "vuex";
export default {
  components: {
    // InLogin,
    // ExLogin,
    IntergrateLogin,
  },
  data() {
      return {
          isExternal : null
      }
  },
  created(){
    this.initTransForm();
  },
  mounted() {
      //this.inOutCheck();
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
     /* 
        ToDo :  ApiAuthController.java 에 망 구분자 값 받아오는 service 호출
                externalwebserver : 내부망(false) / 외부망(true)
                inOutKbn          : 내부망(IN) / 외부망(OUT)
    */
    inOutCheck() {
      let obj = this;
      let reqData = {
        url: "/api/auth/inOutCheck",
        method: "post"
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function(res) {
          if(res.errorCode != null) {

          } else {
            localStorage.setItem("isExternal", res);
            //obj.isExternal = false;
            if (res === "IN") {
                obj.isExternal = false
            } else {
                obj.isExternal = true;
            }
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },

    initTransForm() {
      let Authorization = localStorage.getItem("Authorization");
      if (Authorization !== null && Authorization !== undefined) {
        let obj = this;
        let reqData = {
          url : "/api/org/checkSmgr",
          method : "post"
        };
        obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function(res) {
          if(res.errorCode != null) {
            // console.log(res.errorCode)
          } else {
            obj.$router.replace("/general/home");
          }
        })
        .catch(function(err) {
          console.log(err);
        });
      } else {
        // this.$router.replace("/login")
      }
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/cowork/login/Login.vue